module.exports = __webpack_public_path__ + "img/lr.513f0467.svg";